import { FunctionComponent } from 'react';
import classnames from 'classnames';

import { IndexLevel } from 'components/modules/public/layout/articles/ArticleWrapper';

import { Props } from './index';
import StyledComponent from './styles';

const PublicBlogsArticleIndex: FunctionComponent<Props> = ({ indexStructure, style }) => {
    return (
        <StyledComponent className={classnames('public-layout-articles-index', {
            'notEmpty': Boolean(Object.keys(indexStructure).length > 1),
        }, style)}
        >
            <div className="index-level index-level-1">
                <p className="index-title">Spis treści</p>
                {Object.keys(indexStructure).map(indexL1Key => {
                    const indexL1: IndexLevel = indexStructure[indexL1Key];

                    return (
                        <div
                            className="index-element index-element-level-1"
                            key={indexL1.key}
                        >
                            <a
                                href={`#indexl1-${indexL1.order}`}
                                className="index-text"
                            >
                                <span>{`${indexL1.order}.`}</span>
                                {indexL1.text}
                            </a>

                            {Object.keys(indexL1.elements).length > 0 && (
                                <div className="index-level index-level-2">
                                    {Object.keys(indexL1.elements).map(indexL2Key => {
                                        const indexL2: IndexLevel = indexL1.elements[indexL2Key];

                                        return (
                                            <div
                                                className="index-element index-element-level-2"
                                                key={indexL2.key}
                                            >
                                                <a
                                                    href={`#indexl2-${indexL2.order}`}
                                                    className="index-text"
                                                >
                                                    <span>{`${indexL1.order}.`}{`${indexL2.order}.`}</span>
                                                    {indexL2.text}
                                                </a>

                                                {Object.keys(indexL2.elements).length > 0 && (
                                                    <div className="index-level index-level-3">
                                                        {Object.keys(indexL2.elements).map(indexL3Key => {
                                                            const indexL3: IndexLevel = indexL2.elements[indexL3Key];

                                                            return (
                                                                <div
                                                                    className="index-element index-element-level-3"
                                                                    key={indexL3.key}
                                                                >
                                                                    <a
                                                                        href={`#indexl2-${indexL3.order}`}
                                                                        className="index-text"
                                                                    >
                                                                        <span>{`${indexL1.order}.`}{`${indexL2.order}.`}{`${indexL3.order}.`}</span>
                                                                        {indexL3.text}
                                                                    </a>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </StyledComponent>
    );
};

export default PublicBlogsArticleIndex;